<template>
  <el-select
    v-model="agency"
    :loading="loading"
    :remote-method="getAll"
    :remote="true"
    :key="keys"
    filterable
    clearable
    placeholder="Select Agency"
    @clear="updateParent"
    @change="updateParent">
    <el-option v-for="agency in agencies" :key="agency.id" :value="agency.id" :label="agency.name">{{ agency.name }}</el-option>
  </el-select>
</template>

<script>
import { Agency } from '@/api/payroll/agency'
export default {
  name: 'SelectAgency',
  props: {
    agen: {
      default: null,
      type: Object
    }
  },
  data() {
    return {
      loading: false,
      agency: {},
      agencies: [],
      keys: 0,
      defaultAgency: {
        id: -1,
        name: 'default',
        desc: 'Select Agency'
      }
    }
  },
  watch: {
    agen: function(item) {
      // console.log(item)
      this.agency = item || null
      this.keys++
    }
  },
  created() {
    this.agencies = this.agencies.filter(function(element) {
      return element !== undefined
    })
    if (this.agency) {
      this.agencies = [this.defaultAgency, this.agen]
      this.agency = this.agen
    }
  },
  methods: {
    updateParent(id) {
      this.$emit('setAgency', id)
    },
    getAll(query) {
      if (query.length > 2) {
        this.loading = true
        setTimeout(() => {
          Agency({ per_page: 999, term: query }, 'get').then(res => {
            this.agencies = res.data.agencies
            this.loading = false
          }).catch(() => {})
        }, 100)
      } else {
        this.benefits = []
      }
    },
    getDefault(query) {
      setTimeout(() => {
        Agency({ per_page: 999, term: query }, 'get').then(res => {
          this.agencies = res.data.agencies
          this.loading = false
        }).catch(() => {})
      }, 100)
    }
  }
}
</script>

<style scoped>

</style>
